import { render } from "./sh-register.vue?vue&type=template&id=7dcf2c70&scoped=true"
import script from "./sh-register.vue?vue&type=script&lang=js"
export * from "./sh-register.vue?vue&type=script&lang=js"

import "./sh-register.vue?vue&type=style&index=0&id=7dcf2c70&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcf2c70"]])

export default __exports__